module.exports = __webpack_public_path__ + "media/audios/kid/lesson_7/audio38-55117f270fd93408167bc6af43d46053.m4a";